import { render, staticRenderFns } from "./ClasesDeIngles.vue?vue&type=template&id=11872c6c&scoped=true"
import script from "./ClasesDeIngles.vue?vue&type=script&lang=js"
export * from "./ClasesDeIngles.vue?vue&type=script&lang=js"
import style0 from "./ClasesDeIngles.vue?vue&type=style&index=0&id=11872c6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11872c6c",
  null
  
)

export default component.exports